export const configMouseFlow = () => `
  window.datalayer = window.datalayer || [];
  window._mfq = window._mfq || [];
  (function() {
    var mf = document.createElement("script");
    mf.type = "text/javascript"; mf.defer = true;
    mf.src = "//cdn.mouseflow.com/projects/${process.env.NEXT_PUBLIC_MOUSEFLOW_KEY}.js";
    document.getElementsByTagName("head")[0].appendChild(mf);
})();`;

export const addRecordingTag = (tag: string) => {
  const TAG_KEY = 'tag';
  const tagFormatted = `crm-cx:${tag}`;

  // @ts-expect-error type of window does not have _mfq
  window._mfq = window._mfq || [];

  // @ts-expect-error type of window does not have _mfq
  window._mfq.push([TAG_KEY, tagFormatted]);
};
